import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractPeriodColumnTemplate from "./AbstractPeriodColumnTemplate.js";
import PeriodChangeColumn from "../../reports/columns/PeriodChangeColumn.js";

/**
 * Period change column template.
 */
export default class ChangeColumnTemplate extends AbstractPeriodColumnTemplate {
	accept(visitor) {
		return visitor.visitPeriodChangeColumnTemplate(this);
	}

	_instanceClass() {
		return PeriodChangeColumn;
	}

	static getLabel() {
		return _("Period");
	}

	static getType() {
		return "ChangePeriodColumnTemplate";
	}
}
